var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicationDesign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2b00c3e0-bc4c-4854-b06a-a755b78c307a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.1,
    height: 70.7,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60.1 70.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-9a91cf3d-a596-472f-9a01-fbdab53b18c0{fill:url(#uuid-555e0779-f16d-49f9-9136-d47a4fb3e01d);stroke:url(#uuid-a959226c-d494-4171-98ae-16d623676927);}.uuid-9a91cf3d-a596-472f-9a01-fbdab53b18c0,.uuid-6ae08702-da9d-4de3-96f0-1781609977b7,.uuid-bef6bd47-f77a-413a-9c55-d75128a6cccd,.uuid-704f4e03-d78d-4216-ba16-803441ba410d,.uuid-caada358-b91c-4ca4-9699-ca7034e0b162,.uuid-fb4cbd40-ab50-42c5-85e6-c555f9a419da,.uuid-edb2958f-00c9-4535-8fde-562d5f5a5c44,.uuid-b8c92e64-81da-4498-8e1d-89f55fdfbb2d,.uuid-02eb4ccf-6e32-41e0-ba94-cc579d49ff06{stroke-miterlimit:10;stroke-width:.2px;}.uuid-6ae08702-da9d-4de3-96f0-1781609977b7{fill:url(#uuid-dec16782-5007-4194-9bd2-2fa039971828);stroke:url(#uuid-8d0ba1c4-3867-4ec8-ab5f-ee92bcd839d3);}.uuid-bef6bd47-f77a-413a-9c55-d75128a6cccd{fill:url(#uuid-e6151c54-435b-40ab-b634-a25eaeb477b8);stroke:url(#uuid-3d6e7945-8eb8-4f6d-bcd2-5106b861089a);}.uuid-704f4e03-d78d-4216-ba16-803441ba410d{fill:url(#uuid-ae1abd5b-5ae8-4c5e-9021-525c8ced236a);stroke:url(#uuid-1c3cda5d-e5a1-4919-993e-d5271cf2d936);}.uuid-caada358-b91c-4ca4-9699-ca7034e0b162{fill:url(#uuid-afd9332a-14cb-49fd-87f9-715237068a08);stroke:url(#uuid-301da669-4c6c-457f-897f-ef09f6c86b3e);}.uuid-fb4cbd40-ab50-42c5-85e6-c555f9a419da{fill:url(#uuid-72e8bb06-6542-409a-8692-b690365feeb6);stroke:url(#uuid-10c9ed4f-f3eb-4ce5-9f1a-aa119f0a53dd);}.uuid-edb2958f-00c9-4535-8fde-562d5f5a5c44{fill:url(#uuid-28fcc6f1-3868-4682-9e4f-ae98cc641350);stroke:url(#uuid-d957fd52-d49b-4d70-9d63-c9b42b3fb8bc);}.uuid-b8c92e64-81da-4498-8e1d-89f55fdfbb2d{fill:url(#uuid-9076be30-0bea-4593-800e-6056f457fdcc);stroke:url(#uuid-c4f56bad-37bd-44c4-b644-b1c37cb6bdd0);}.uuid-02eb4ccf-6e32-41e0-ba94-cc579d49ff06{fill:url(#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f);stroke:url(#uuid-7036149a-cfd3-487a-8a94-7f72d783ba40);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-6115d4b4-87f0-4964-b97f-398babe83f7f",
    x1: 0.1,
    y1: 35.3,
    x2: 60,
    y2: 35.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab73d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-7036149a-cfd3-487a-8a94-7f72d783ba40",
    x1: 0,
    x2: 60.1,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-dec16782-5007-4194-9bd2-2fa039971828",
    x1: 7.8,
    y1: 33.9,
    x2: 26.6,
    y2: 33.9,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-8d0ba1c4-3867-4ec8-ab5f-ee92bcd839d3",
    x1: 7.6,
    y1: 33.9,
    x2: 26.7,
    y2: 33.9,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-555e0779-f16d-49f9-9136-d47a4fb3e01d",
    x1: 33.5,
    y1: 33.9,
    x2: 52.3,
    y2: 33.9,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a959226c-d494-4171-98ae-16d623676927",
    x1: 33.4,
    y1: 33.9,
    x2: 52.4,
    y2: 33.9,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-afd9332a-14cb-49fd-87f9-715237068a08",
    x1: 7.8,
    y1: 40.6,
    x2: 26.6,
    y2: 40.6,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-301da669-4c6c-457f-897f-ef09f6c86b3e",
    x1: 7.6,
    y1: 40.6,
    x2: 26.7,
    y2: 40.6,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-72e8bb06-6542-409a-8692-b690365feeb6",
    x1: 33.5,
    y1: 40.6,
    x2: 52.3,
    y2: 40.6,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-10c9ed4f-f3eb-4ce5-9f1a-aa119f0a53dd",
    x1: 33.4,
    y1: 40.6,
    x2: 52.4,
    y2: 40.6,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-9076be30-0bea-4593-800e-6056f457fdcc",
    x1: 7.8,
    y1: 47.3,
    x2: 26.6,
    y2: 47.3,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c4f56bad-37bd-44c4-b644-b1c37cb6bdd0",
    x1: 7.6,
    y1: 47.3,
    x2: 26.7,
    y2: 47.3,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-28fcc6f1-3868-4682-9e4f-ae98cc641350",
    x1: 33.5,
    y1: 47.3,
    x2: 52.3,
    y2: 47.3,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-d957fd52-d49b-4d70-9d63-c9b42b3fb8bc",
    x1: 33.4,
    y1: 47.3,
    x2: 52.4,
    y2: 47.3,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ae1abd5b-5ae8-4c5e-9021-525c8ced236a",
    x1: 7.8,
    y1: 54.1,
    x2: 26.6,
    y2: 54.1,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1c3cda5d-e5a1-4919-993e-d5271cf2d936",
    x1: 7.6,
    y1: 54.1,
    x2: 26.7,
    y2: 54.1,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e6151c54-435b-40ab-b634-a25eaeb477b8",
    x1: 33.5,
    y1: 54.1,
    x2: 52.3,
    y2: 54.1,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-3d6e7945-8eb8-4f6d-bcd2-5106b861089a",
    x1: 33.4,
    y1: 54.1,
    x2: 52.4,
    y2: 54.1,
    xlinkHref: "#uuid-6115d4b4-87f0-4964-b97f-398babe83f7f"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-2cabe7f1-3902-4051-bb2a-12da1e749b6a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-02eb4ccf-6e32-41e0-ba94-cc579d49ff06",
    d: "M59.4,29.7h-2.8v-2.6c0-.2,0-.4-.3-.5-8.5-5.1-14.1-2.7-15.2-2.1,0,0-.2.1-.3.2h0s0,0,0,0h0c-3.3,1.6-7,2.1-10.6,1.3-.6-.1-1.2-.3-1.7-.5h-.2c0,0,0-.3,0-.3,0-.1,0-.3,0-.4l-1.4-7.8h2.5s0,0,.1,0h0c.6,0,3.5-.2,6,2.3h0s0,.1,0,.1c.8,2.7,1.9,4.1,3.2,4.1,2.7,0,4.2-6,4.2-11.6S41.5.1,38.8.1s-2.3,1.6-2.8,3h0c0,0,0,0,0,0-2.6,2.5-6.2,3.3-6.6,3.4h0s-6.9,0-6.9,0c-2.8,0-5.2,2.3-5.2,5.2s1.7,4.6,4.1,5.1h.2s1.2,6.6,1.2,6.6h-.4c-5.4-.8-9.4,1.7-9.4,1.7-4.4,2.8-6.5,2.8-7.3,2.5-.6-.2-.9-.6-.9-.7h0c0-.3-.3-.5-.6-.4-.3,0-.5.3-.5.6v2.6H.7c-.3,0-.6.2-.6.6v36.2c0,.3.2.6.6.6h22c.8,0,1.4.6,1.4,1.4,0,1.2,1,2.2,2.2,2.2h8.1c1.2,0,2.2-1,2.2-2.3s.6-1.4,1.4-1.4h21.4c.3,0,.6-.2.6-.6V30.2c0-.3-.2-.6-.6-.6ZM35.9,8.7c.4-4.6,1.9-7.4,2.9-7.4s3.1,4,3.1,10.5-1.8,10.5-3.1,10.5-2.5-2.8-2.9-7.4v-.3s.2,0,.2,0c1.4-.2,2.4-1.4,2.4-2.8s-1-2.6-2.4-2.8h-.3s0-.3,0-.3ZM35.8,10.4v-.3s.3,0,.3,0c.8.2,1.3.9,1.3,1.7s-.5,1.5-1.3,1.7h-.3c0,0,0-.3,0-.3,0-.5,0-.9,0-1.4s0-.9,0-1.4ZM29.8,7.6h.2c1-.3,2.9-.9,4.7-2.1l.6-.4v.6c-.5,1.8-.7,3.9-.7,6s.1,3.4.4,5v.6c0,0-.4-.3-.4-.3-1.7-1-3.4-1.3-4.5-1.3h-.3V7.6ZM30.6,27.1h.3c3.5.6,7.2,0,10.4-1.5l.4-.2c.5-.3,5.6-2.7,13.6,1.9h.1v35.3h-.2c-.3.2-.8.3-1.5.3s-1.5,0-2.5-.4c-1.1-.3-2.1-.8-3-1.6-1.9-1.5-4.7-1.9-5.8-1.9-.1,0-.3,0-.5,0,0,0-.1,0-.2,0-2.3-.3-6.1,0-10.8,2.5l-.4.2V27.1ZM18.2,11.7c0-2.2,1.8-4,4-4h6.5v8.1h-6.5c-2.2,0-4-1.8-4-4ZM22.6,16.9h3.1l1.5,8c0,.1,0,.2,0,.3s0,.2,0,.2h0c0,0,0,.1,0,.2h0c-.2.6-.6,1-1.2,1.1,0,0-.2,0-.3,0-.3,0-.6,0-.9-.3-.3-.2-.6-.6-.6-1l-1.6-8.5ZM4.6,28.6h.3c0,0,.2,0,.2,0,1.8.7,4.6-.2,8.3-2.6h0c.4-.3,4.3-2.4,9.2-1.5h.2s.2,1.1.2,1.1c.1.7.5,1.3,1.1,1.7.4.3,1,.5,1.5.5s.3,0,.5,0h0c.7-.1,1.3-.6,1.7-1.2v-.2c.1,0,.3,0,.3,0,.4.1.8.2,1.1.3h.2v34.9l-.4-.2c-8.5-4.7-14.1-1.7-14.7-1.3-4,2.3-6.6,2.8-8.1,2.8-.7,0-1.2,0-1.5-.2h-.2V28.6ZM58.9,65.8h-20.8c-1.4,0-2.5,1.1-2.5,2.5s-.5,1.1-1.1,1.1h-8.1c-.6,0-1.1-.5-1.1-1.1,0-1.4-1.1-2.5-2.5-2.5H1.2V30.8h2.2v32.2c0,.2.1.4.2.5.3.2,1,.6,2.5.6s4.4-.5,8.7-3c0,0,0,0,0,0,.4-.2,1.8-.9,4-1,2.3-.1,6.1.3,10.6,3.1h0c0,0,.2.1.3.1s0,0,0,0h0s0,0,0,0c0,0,.1,0,.2,0,4.9-3.1,8.9-3.4,11.3-3.1.3,0,.5,0,.7,0,.3,0,3.4.2,5.2,1.7,1.1.9,2.2,1.5,3.5,1.8,3.5.9,5.1,0,5.4-.2.1-.1.2-.3.2-.5V30.8h2.2v35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-6ae08702-da9d-4de3-96f0-1781609977b7",
    d: "M8.3,33.3c-.3,0-.6.2-.6.6s.2.6.6.6h17.7c.3,0,.6-.2.6-.6s-.2-.6-.6-.6H8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9a91cf3d-a596-472f-9a01-fbdab53b18c0",
    d: "M51.7,33.3h-17.7c-.3,0-.6.2-.6.6s.2.6.6.6h17.7c.3,0,.6-.2.6-.6s-.2-.6-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-caada358-b91c-4ca4-9699-ca7034e0b162",
    d: "M8.3,40.1c-.3,0-.6.2-.6.6s.2.6.6.6h17.7c.3,0,.6-.2.6-.6s-.2-.6-.6-.6H8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-fb4cbd40-ab50-42c5-85e6-c555f9a419da",
    d: "M51.7,40.1h-17.7c-.3,0-.6.2-.6.6s.2.6.6.6h17.7c.3,0,.6-.2.6-.6s-.2-.6-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b8c92e64-81da-4498-8e1d-89f55fdfbb2d",
    d: "M8.3,46.8c-.3,0-.6.2-.6.6s.2.6.6.6h17.7c.3,0,.6-.2.6-.6s-.2-.6-.6-.6H8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-edb2958f-00c9-4535-8fde-562d5f5a5c44",
    d: "M51.7,46.8h-17.7c-.3,0-.6.2-.6.6s.2.6.6.6h17.7c.3,0,.6-.2.6-.6s-.2-.6-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-704f4e03-d78d-4216-ba16-803441ba410d",
    d: "M8.3,53.5c-.3,0-.6.2-.6.6s.2.6.6.6h17.7c.3,0,.6-.2.6-.6s-.2-.6-.6-.6H8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-bef6bd47-f77a-413a-9c55-d75128a6cccd",
    d: "M51.7,53.5h-17.7c-.3,0-.6.2-.6.6s.2.6.6.6h17.7c.3,0,.6-.2.6-.6s-.2-.6-.6-.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicationDesign);
export default __webpack_public_path__ + "static/media/Publication Design.1b3728bd58f03554daa65c7727175132.svg";
export { ForwardRef as ReactComponent };